import React from 'react';
import {Images} from 'utils';
import {Loader} from 'components';
import {NoteStatusBadge} from '../../../schedule/core/modals/apptDetail/constants';
import {renderTimeAgo} from '../../../chat/constants';
import {docEntryNoun, entryPreview} from './constants';
import {TextRow} from "components";

export const DocumentationHistory = ({
                                         clientName,
                                         entries,
                                         activeTab,
                                         selectedId,
                                         isCreating,
                                         onSelect,
                                         onAddNew,
                                         loading,
                                     }) => (
    <div className="sdoc-history">
        <div className="sdoc-history-header">
            <div>
                <p className="sdoc-history-title">History</p>
                <p className="sdoc-history-subtitle">
                    {`Session for ${clientName || '—'} • ${entries?.length || 0} ${entries?.length === 1 ? 'entry' : 'entries'}`}
                </p>
            </div>
            <button type="button" className="sdoc-add-entry-btn" onClick={onAddNew}>
                <img src={Images.addCircle} alt="add"/>
                <span>Add new entry</span>
            </button>
        </div>

        <div className="sdoc-history-list">
            {loading ? (
                <Loader height={'200px'} circleSize={40}/>
            ) : (
                <>
                    {isCreating && (
                        <button type="button" className="sdoc-history-item sdoc-history-item-active" onClick={onAddNew}>
                            <div className="sdoc-history-item-main" style={{background: ''}}>
                                <p className="sdoc-history-item-title">{`New ${docEntryNoun[activeTab]}`}</p>
                                <p className="sdoc-history-item-preview sdoc-history-item-muted">New entry</p>
                                <p className="sdoc-history-item-time">Not saved yet</p>
                            </div>
                        </button>
                    )}

                    {entries?.map((entry) => {
                        return <button
                            type="button"
                            key={entry?.id}
                            onClick={() => onSelect(entry)}
                            className={`sdoc-history-item ${!isCreating && selectedId === entry?.id ? 'sdoc-history-item-active' : ''}`}
                        >
                            <div className="sdoc-history-item-main"
                                 style={{borderColor: !isCreating && selectedId === entry?.id ? '#0b5dcf' : 'transparent'}}>
                                <p className="sdoc-history-item-title">
                                    <TextRow name={entry?.template?.title} fontWeight={600}/>
                                </p>
                                <p className="sdoc-history-item-preview">{entryPreview(entry) || 'No content yet'}</p>

                                <div className='flex-align-center' style={{gap: 4, marginTop: '4px' }}>
                                    <img
                                        src={Images.clock}
                                        alt="clock"
                                        style={{filter: 'brightness(0) saturate(100%) invert(72%) sepia(6%) saturate(510%) hue-rotate(179deg) brightness(91%) contrast(83%)'}}
                                    />
                                    <p className="sdoc-history-item-time">{renderTimeAgo(entry?.created)}</p>
                                </div>
                            </div>
                            <NoteStatusBadge status={entry?.status} doNotShowIcon/>
                        </button>
                    })}

                    {!entries?.length &&
                        <p className="sdoc-history-empty">No entries recorded for this session yet.</p>}
                </>
            )}
        </div>
    </div>
);
